import { motion } from 'motion/react';
import styles from './Question.module.css';
import { useGetParams } from '../../hooks/useGetParams';

function Question({ title, initDelay }) {
  const { questionFontSize } = useGetParams();

  const isLong = title?.length > 145;

  return (
    <div
      key={title}
      className={styles.question}
      style={{
        fontSize: isLong
          ? `${0.8 * questionFontSize}rem`
          : `${questionFontSize}rem`,
      }}
    >
      {title && (
        <motion.div
          className={styles.line}
          initial={{ x: '100vw' }}
          animate={{ x: 0 }}
          transition={{ duration: 1.56, delay: initDelay + 0.36 }}
        >
          <div>{title}</div>
        </motion.div>
      )}
    </div>
  );
}

export default Question;
